import { render, staticRenderFns } from "./_Populasi.vue?vue&type=template&id=d3e37c12&"
import script from "./_Populasi.vue?vue&type=script&lang=js&"
export * from "./_Populasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports